var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditUserGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.887,
    height: 30.413,
    viewBox: "0 0 29.887 30.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3000",
    "data-name": "Group 3000",
    transform: "translate(0 0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_766",
    "data-name": "Groupe 766",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    transform: "translate(4.399 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M-536.767,390.852a7.247,7.247,0,0,1-7.239-7.238,7.248,7.248,0,0,1,7.239-7.239,7.247,7.247,0,0,1,7.238,7.239A7.247,7.247,0,0,1-536.767,390.852Zm0-12.218a4.986,4.986,0,0,0-4.98,4.98,4.985,4.985,0,0,0,4.98,4.979,4.984,4.984,0,0,0,4.979-4.979A4.985,4.985,0,0,0-536.767,378.633Z",
    transform: "translate(544.006 -376.374)",
    fill: "#3e3e3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_390",
    "data-name": "Trac\\xE9 390",
    transform: "translate(0 15.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M-531.81,413.932h-15.071a4.1,4.1,0,0,1-3.392-1.8,4.1,4.1,0,0,1-.423-3.821,12.141,12.141,0,0,1,11.35-7.714A12.143,12.143,0,0,1-528,408.315a4.1,4.1,0,0,1-.423,3.821A4.1,4.1,0,0,1-531.81,413.932Zm-7.536-11.072a9.892,9.892,0,0,0-9.25,6.286,1.823,1.823,0,0,0,.19,1.72,1.819,1.819,0,0,0,1.525.807h15.071a1.819,1.819,0,0,0,1.525-.807,1.823,1.823,0,0,0,.19-1.72,9.894,9.894,0,0,0-9.249-6.286Z",
    transform: "translate(550.985 -400.601)",
    fill: "#3e3e3e"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_212",
    cx: 6.589,
    cy: 6.589,
    rx: 6.589,
    ry: 6.589,
    transform: "translate(16.708 17.234)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M3.594,1.153,5.176,2.736,1.74,6.172.329,6.328A.3.3,0,0,1,0,6L.158,4.588,3.594,1.153ZM6.155.917,5.412.174a.594.594,0,0,0-.84,0l-.7.7L5.456,2.456l.7-.7a.594.594,0,0,0,0-.84Z",
    transform: "translate(20.134 20.658)",
    fill: "#f5f5f5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUserGrey);
export default __webpack_public_path__ + "static/media/editUserGrey.0d0b16d50d950720d63cf32b48c18ff7.svg";
export { ForwardRef as ReactComponent };